// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3G3c-","inner":"Footer_inner__1ixOe","nextIcon":"Footer_nextIcon__2YLhB","innerLeft":"Footer_innerLeft__3E_kc"};